import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=6833eaa4"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=6833eaa4&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports